import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  SxProps,
  Theme,
  Typography,
  useTheme,
} from "@mui/material";
import { useIntl } from "react-intl";

const useStyles = (theme: Theme): { [key: string]: SxProps } => ({
  button: {
    backgroundColor: theme.palette.error.main,
  },
  title: {
    fontWeight: "bold",
  },
});

type ConfirmDeactivateUsersDialogProps = {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export function ConfirmDeactivateUsersDialog({
  open,
  onConfirm,
  onCancel,
}: Readonly<ConfirmDeactivateUsersDialogProps>) {
  const styles = useStyles(useTheme());
  const { formatMessage: t } = useIntl();

  return (
    <Dialog open={open} maxWidth="xs" fullWidth onClose={onCancel}>
      <DialogContent>
        <Box display="flex" alignItems="center" gap={2} mb={2}>
          <Typography variant="h6" sx={styles.title}>
            {t({ id: "deactivateTheseUsers" })}
          </Typography>
        </Box>
        <Alert severity="error">
          {t({ id: "deactivationCannotBeUndoneInBulk" })}
        </Alert>
      </DialogContent>
      <DialogActions>
        <Grid container spacing={2} justifyContent="right">
          <Grid item xs={12} sm={12} md={4}>
            <Button onClick={onCancel} fullWidth>
              {t({ id: "cancel" })}
            </Button>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Button
              variant="contained"
              sx={styles.button}
              onClick={onConfirm}
              autoFocus
              fullWidth
            >
              {t({ id: "deactivateUsers" })}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
}
